import { TechnologyPageProps } from './TechnologyPage.types'
import { PageWrapper } from '@otomoro/components/layout/PageWrapper'
import { FlexibleContent } from '@otomoro/components/shared/FlexibleContent'
import { Headline } from '@otomoro/components/shared/Headline'
import { Map } from '@otomoro/components/technology/Map/Map'
import { PortableTextObject } from 'sanity'
import { VideoHero } from '@otomoro/components/home/videoHero/VideoHero'

type PortableTextType = PortableTextObject | undefined

export default function TechnologyPage({ data }: TechnologyPageProps & {
  data: {
    headline: string
    subHeadline: string
    map: {
      sliderTag: string
      sliderHeadline: PortableTextType
      tag: string
      headline: PortableTextType
      locationsList: any[]
      topImageSlider: any[]
    }
    flexibleContent: any[]
  }
}) {
  if (!data) {
    return (
      <div className="text-center">
        Please start editing your Technology document to see the preview!
      </div>
    )
  }

  return (
    <PageWrapper noPb theme="light">
      <Headline
        size="large"
        border
        headlineText={data.headline}
        subheadline={data.subHeadline}
        healineSize="31px"
      ></Headline>
      {/* Add spacing before the video */}
      <div className="mt-6">
        <VideoHero
          videoUrl="https://player.vimeo.com/video/1078681688?h=83df1be540&title=0&byline=0&portrait=0&"
          title={{
            _type: 'block',
            _key: 'tech-title',
            children: [
              {
                _type: 'span',
                _key: 'span-1',
                text: 'WE ARE SHIFTING FROM FOSSIL BASED DEPENDENCY TO A FUTURE POWERED BY ',
              },
              {
                _type: 'span',
                _key: 'span-2',
                text: 'SAFE AND SUSTAINABLE SOLUTIONS',
                marks: ['pink'],
              }
            ]
          }}
        />
      </div>

      <FlexibleContent blocks={data?.flexibleContent as any} />

      <Map
        sliderTag={data?.map?.sliderTag as string}
        sliderHeadline={data?.map?.sliderHeadline as PortableTextType}
        tag={data?.map?.tag as string}
        headline={data?.map?.headline as PortableTextType}
        locationsList={data?.map?.locationsList as any[]}
        topImageSlider={data?.map?.topImageSlider as any[]}
      />
    </PageWrapper>
  )
}
